import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useNavigate } from "@tanstack/react-router";
import { Content } from "shared/components/global/Content";
import { useOptInUserFormContext } from "shared/components/opt-in/context";
import { useFormState } from "shared/hooks/useFormState";
import { useOptInUserMutation } from "shared/hooks/useGraphql";
import { fail } from "shared/utils/fns";
import { logger } from "shared/utils/logger";
import { graphql } from "src/gql";

export const DeleteAccountPanel = () => {
    const nav = useNavigate();
    const form = useOptInUserFormContext();
    const [userId] = useFormState(form, "id");

    const archiveUser = useOptInUserMutation(
        graphql(`
            mutation OptInArchiveSelfService($userId: UUID!) {
                archiveUser(userId: $userId)
            }
        `),
    );

    function openDeleteAccountModal() {
        modals.openConfirmModal({
            title: "Delete account",
            children: "Are you sure you want to delete your account? This action cannot be undone.",
            labels: { confirm: "Delete account", cancel: "Cancel" },
            confirmProps: { color: "red" },
            onCancel: modals.closeAll,
            onConfirm: () => {
                if (!userId) return fail("Unknown user ID");
                archiveUser
                    .mutateAsync({ userId })
                    .then(() => nav({ to: "/opt-in" }))
                    .catch(logger.error);
            },
        });
    }
    return (
        <Content paper>
            <Content.Heading id="delete">Delete Account</Content.Heading>
            <Text>
                Deleting your account is permanent and cannot be undone. All your data, settings, and content will be permanently lost.
            </Text>
            <Button color="red" onClick={openDeleteAccountModal}>
                Delete Account
            </Button>
        </Content>
    );
};
